// extracted by mini-css-extract-plugin
export default {"shortcut-hint":"shortcut-hint_shortcut-hint__RYzOR","show":"shortcut-hint_show__NxiF5","button":"shortcut-hint_button__MAr8j"};